"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      background: palette.common.white,
      position: 'relative'
    },
    border: {
      border: "1px solid ".concat(palette.grey.main),
      borderRadius: 5,
      padding: 12
    },
    labelText: {
      background: palette.common.white,
      padding: 5,
      position: 'absolute',
      top: -10
    },
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    button: {
      background: palette.green.dark,
      marginRight: spacing(2),
      color: palette.common.white,
      '&:hover': {
        background: palette.green.superDark
      }
    },
    hiddenInput: {
      display: 'none'
    },
    noFile: {
      color: palette.grey.main
    },
    imagePreview: function imagePreview(_ref2) {
      var image = _ref2.image;
      return {
        width: 48,
        height: 48,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: image ? "url('".concat(image, "')") : '',
        backgroundSize: 'contain'
      };
    }
  };
});

var FileInput = function FileInput(_ref3) {
  var _ref3$id = _ref3.id,
      id = _ref3$id === void 0 ? 'input-file' : _ref3$id,
      fileName = _ref3.fileName,
      onChange = _ref3.onChange,
      _ref3$error = _ref3.error,
      error = _ref3$error === void 0 ? '' : _ref3$error,
      _ref3$accept = _ref3.accept,
      accept = _ref3$accept === void 0 ? '*' : _ref3$accept,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? 'Upload file' : _ref3$label,
      _ref3$buttonText = _ref3.buttonText,
      buttonText = _ref3$buttonText === void 0 ? 'Choose file' : _ref3$buttonText,
      renderPreview = _ref3.renderPreview,
      hintText = _ref3.hintText;
  var classes = useStyles({
    image: fileName
  });
  var labelEl = (0, _react.useRef)(null);

  var defaultPreview = fileName && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.noFile
  }, "No file chosen");

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.border
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: (0, _classnames["default"])('Label-Input-Set', classes.labelText)
  }, label), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: classes.label,
    ref: labelEl
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    className: classes.button,
    onClick: function onClick() {
      var _labelEl$current;

      (_labelEl$current = labelEl.current) === null || _labelEl$current === void 0 ? void 0 : _labelEl$current.click();
    }
  }, buttonText), renderPreview ? renderPreview(fileName) : defaultPreview, /*#__PURE__*/_react["default"].createElement("input", {
    id: id,
    type: "file",
    accept: accept,
    onChange: onChange,
    className: classes.hiddenInput
  }))), hintText && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    mt: 1,
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: "Subcopy-Static-Alt"
  }, hintText)))), /*#__PURE__*/_react["default"].createElement(_material.Grid, null, /*#__PURE__*/_react["default"].createElement(_material.Slide, {
    direction: "left",
    "in": !!error
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: "Body-Regular-Center-Error"
  }, error)))));
};

var _default = /*#__PURE__*/(0, _react.memo)(FileInput);

exports["default"] = _default;